module.exports = __webpack_public_path__ + "static/media/fascadeDepotTown.c63dac54.jpg";